// Vuetify 2 (mixin `overlayable`) blokuje przewijanie strony pod otwartym `v-dialog`,
// wieszając na `window` listener `wheel` z `passive: false`, który woła `preventDefault()`
// na każdym zdarzeniu bez przewijalnego przodka w danym kierunku. Nie ma w nim wyjątku
// dla `ctrlKey`, a ctrl+kółko (oraz pinch na touchpadzie, który Chrome zgłasza identycznie)
// to zoom przeglądarki — `preventDefault()` go wyłącza. Objaw: przy otwartym modalu
// (np. „Dodaj pliki") stronę da się oddalić, ale nie przybliżyć, zależnie od tego, czy
// element pod kursorem akurat „może" się przewinąć w kierunku ruchu kółka (zgłoszenie QA).
//
// Guard łapie `wheel` w fazie capture na `window` — czyli ZANIM dojdzie do listenera
// Vuetify (bubble na tym samym `window`) — i dla gestu zoomu ucina dalsze przetwarzanie.
// Nie woła `preventDefault()`, więc przeglądarka zoomuje normalnie; `passive: true` mówi
// jej wprost, że nie zamierzamy. Aplikacja nigdzie nie obsługuje ctrl+kółka, więc poza
// blokadą Vuetify nikt tego zdarzenia nie traci.

export function isBrowserZoomGesture(e: WheelEvent): boolean {
  return e.ctrlKey;
}

export function installBrowserZoomGuard(target: Window = window): () => void {
  const guard = (e: WheelEvent) => {
    if (isBrowserZoomGesture(e)) {
      e.stopImmediatePropagation();
    }
  };
  target.addEventListener('wheel', guard, { capture: true, passive: true });
  return () => target.removeEventListener('wheel', guard, { capture: true });
}
